module.exports = __webpack_public_path__ + "img/awards_chip3.b9d24f90.png";